export enum ApplicationUserRole {
    MANAGER = 'manager',
}
